module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/231-libya-40fb46d1c8820f2f46683df7fcfa19ff.svg";